export default __webpack_public_path__ + "static/media/css.e7a9de36.svg";